import { SET_LANGUAGE } from './constants';

export const setLanguage = lang => ({
  type: SET_LANGUAGE,
  payload: lang
});
